import { useEffect } from 'react';
import { 
    Box, 
    VStack, 
    HStack, 
    Text, 
    useColorModeValue,
    IconButton,
    SlideFade,
} from '@chakra-ui/react';
import { useAppContext } from '../../context/AppContext';

// Constants
import { UI_CONFIG } from '../../constants';

const NotificationSystem = () => {
    const { notifications, removeNotification } = useAppContext();
    const bgColor = useColorModeValue('white', 'gray.700');
    const borderColor = useColorModeValue('gray.200', 'gray.600');

    // Auto-remove notifications after configured timeout
    useEffect(() => {
        notifications.forEach(notification => {
            if (!notification.persistent) {
                setTimeout(() => {
                    removeNotification(notification.id);
                }, UI_CONFIG.NOTIFICATION_TIMEOUT);
            }
        });
    }, [notifications, removeNotification]);

    if (notifications.length === 0) return null;

    return (
        <Box
            position="fixed"
            top="20px"
            right="20px"
            zIndex={9999}
            maxW="400px"
        >
            <VStack spacing={3} align="stretch">
                {notifications.map(notification => (
                    <SlideFade key={notification.id} in={true} offsetY="20px">
                        <Box
                            bg={bgColor}
                            border="1px solid"
                            borderColor={borderColor}
                            borderRadius="md"
                            p={4}
                            boxShadow="lg"
                            position="relative"
                        >
                            <HStack justify="space-between" align="start">
                                <Box flex={1}>
                                    {notification.title && (
                                        <Text fontWeight="bold" mb={1}>
                                            {notification.title}
                                        </Text>
                                    )}
                                    <Text fontSize="sm" color="gray.600">
                                        {notification.message}
                                    </Text>
                                </Box>
                                
                                <IconButton
                                    size="sm"
                                    variant="ghost"
                                    icon={
                                        <svg
                                            width="16"
                                            height="16"
                                            fill="currentColor"
                                            viewBox="0 0 16 16"
                                        >
                                            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                                        </svg>
                                    }
                                    onClick={() => removeNotification(notification.id)}
                                    aria-label="Cerrar notificación"
                                />
                            </HStack>
                        </Box>
                    </SlideFade>
                ))}
            </VStack>
        </Box>
    );
};

export default NotificationSystem; 